// Optional "paste a link" field under the artwork upload, for files too big for the 20MB upload.
// The link is saved as the visible line-item property "Artwork Link". A valid link counts as
// artwork, same as an uploaded file, so the product pages' Add-to-cart gates read
// [data-artwork-link].dataset.valid and listen for "inkora:artwork-link" / "artwork:change".
(function () {
  if (window.__inkoraArtworkLink) return;
  window.__inkoraArtworkLink = true;

  var URL_RE = /^https?:\/\/[^\s\/$.?#][^\s]*\.[^\s]{2,}$/i;
  var WRAP_SELECTOR = 'inkora-artwork-upload, inkora-artwork-upload-custom-size';

  function bind(link) {
    if (link.dataset.bound) return;
    var wrap = link.closest(WRAP_SELECTOR);
    if (!wrap) return;
    link.dataset.bound = '1';

    var file = wrap.querySelector('.inkora-artwork-upload__input');
    var errorMsg = wrap.querySelector('[data-artwork-link-msg]');
    var linkOk = wrap.querySelector('[data-artwork-link-ok]');
    var fileOk = wrap.querySelector('[data-artwork-success]');
    var proofing = document.querySelector(
      '[data-inkora-proofing][data-section-id="' + wrap.dataset.sectionId + '"]'
    );
    var wasRequired = !!file && file.hasAttribute('required');

    function hasFile() {
      return !!file && !!file.files && file.files.length > 0;
    }

    function sync() {
      var text = link.value.trim();
      var valid = URL_RE.test(text);
      link.dataset.valid = valid ? 'true' : 'false';
      link.classList.toggle('is-invalid', text !== '' && !valid);
      if (errorMsg) errorMsg.hidden = !(text !== '' && !valid);
      // A valid link replaces the file, so the browser must not demand one.
      if (file && wasRequired) file.required = !valid;
      wrap.classList.toggle('has-link', valid);
      if (linkOk) linkOk.hidden = !(valid && !hasFile());
      if (!hasFile()) {
        if (fileOk) fileOk.hidden = true;
        if (proofing) {
          var wasHidden = proofing.hidden;
          proofing.hidden = !valid;
          if (valid && wasHidden) proofing.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      wrap.dispatchEvent(new CustomEvent('artwork:change', { bubbles: true }));
      wrap.dispatchEvent(new CustomEvent('inkora:artwork-link', { bubbles: true }));
    }

    link.addEventListener('input', sync);
    link.addEventListener('change', sync);

    if (file) {
      // The upload is locked until every option is chosen; the link field follows it.
      link.disabled = file.disabled;
      new MutationObserver(function () {
        link.disabled = file.disabled;
      }).observe(file, { attributes: true, attributeFilter: ['disabled'] });
      // Picking a file hides the "link added" note (the file note takes over).
      file.addEventListener('change', function () {
        if (linkOk) linkOk.hidden = !(link.dataset.valid === 'true' && !hasFile());
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-artwork-link]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
